import { TocService } from "./toc";
import { Tabs } from "../../components/base/block-tabs";
import ServiceLocator from "../../global/service-locator";
import {throttle} from "../../lib";
import DOMHelper from "../../lib/dom-helper";

export class WikiTocMobile {
    constructor($root, options = {}) {
        this.$root = $root;
        this.$trigger = document.querySelector('[data-modal-trigger="toc-mobile"]');
        this.$tabs = this.$root.querySelector('[data-toc-list="listSwitch"]');
        this.$listContainer = this.$root.querySelector('.toc-list');
        this.$linkList = this.$listContainer.querySelectorAll('.toc-link');
        this.$sections = document.querySelectorAll('[data-toc-id]');

        this.shouldAnimate = options.shouldAnimate == null ? true : options.shouldAnimate;

        this.sl = ServiceLocator.instance;
        this.tocService = new TocService();
        this.tabsController = null;

        this.sectionPositions = {};

        this.isInit = false;

        if (this.$root && this.$trigger) {
            this.init();
        }
    }

    init() {
        this.isInit = true;

        if (this.$tabs) {
            this.$linkList = this.$listContainer.querySelectorAll('[data-toc-list="first"] .toc-link');
            this.tabsController = new Tabs({ $root: this.$tabs });
        }

        this.sl.modalService.register(
            'toc-mobile',
            document.querySelector('[data-modal-trigger="toc-mobile"]'),
            {
                enabledScroll: [document.querySelector('.toc-mobile-modal-body')]
            }
        );

        this.collectSectionPositions();
        this.addEventListeners();

        if (Object.keys(this.sectionPositions).includes(window.location.hash.slice(1))) {
            window.scrollTo(0, 0);
            this.tocService.scrollToSection(window.location.hash.slice(1), false);
        }
    }

    refreshOnResize() {
        if (!this.isInit) {
            return;
        }

        this.collectSectionPositions();
    }

    collectSectionPositions() {
        // Collect all section Y positions (minus top margin)
        this.$sections.forEach(($section, i) => {
            let sectionYPos = DOMHelper.getElementTopPosition($section) - this.tocService.scrollPosTopMargin - 5;
            this.sectionPositions[$section.dataset.tocId] = sectionYPos;

            if (i === this.$sections.length - 1) {
                this.lastSectionYBottomPos = sectionYPos + $section.offsetHeight;
            }
        });
    }

    addEventListeners() {
        // Add scroll to section event listeners
        this.$linkList.forEach(($link) => {
            $link.addEventListener('click', () => {
                this.sl.modalService.close();
                const id = $link.href.split('#')[1];
                this.tocService.scrollToSection(id, this.shouldAnimate);
            });
        });

        if (this.tabsController) {
            this.tabsController.subscribe('tabSwitch', ({ detail }) => {
                this.$listContainer.dataset.tocList = detail;
            });
        }

        // Highlight link to the section when it falls into viewport
        window.addEventListener('scroll', throttle(() => {
            this.collectSectionPositions();
            const scrollYPos = window.scrollY;
            let potentialActiveSectionId = null;
            let nextSectionId = null;

            // if current scroll position overlaps any of the section position
            // remember this and next positions
            for (let sectionId in this.sectionPositions) {
                const sectionYPos = this.sectionPositions[sectionId];

                if (scrollYPos >= sectionYPos && scrollYPos < this.lastSectionYBottomPos) {
                    potentialActiveSectionId = sectionId;
                } else if (scrollYPos < sectionYPos) {
                    nextSectionId = sectionId;
                    break;
                }
            }

            // If there is potential active section set it in active state;
            // Otherwise drop active state
            if (
                potentialActiveSectionId &&
                potentialActiveSectionId !== nextSectionId &&
                potentialActiveSectionId !== this.activeSectionId
            ) {
                this.$linkList.forEach(($link) => {
                    const linkId = $link.href.split('#')[1];

                    if ($link.classList.contains('-active')) {
                        $link.classList.remove('-active');
                    } else if (potentialActiveSectionId === linkId) {
                        $link.classList.add('-active');
                        this.activeSectionId = potentialActiveSectionId;
                    }
                });
            } else if (!potentialActiveSectionId && this.activeSectionId) {
                this.$linkList.forEach(($link) => {
                    if ($link.classList.contains('-active')) {
                        $link.classList.remove('-active');
                        this.activeSectionId = null;
                    }
                });
            }
        }, 20));
    }
}